<p-toast></p-toast>
<p-blockUI [blocked]="blocked">
  <p-progressSpinner></p-progressSpinner>
</p-blockUI>

  <p-accordion [multiple]="true" class="col">
    <p-accordionTab [selected]="openFileSelector">
      <ng-template pTemplate="header">
        <h5>Источник данных</h5>
      </ng-template>
      <p-tabView [(activeIndex)]="tabIndex" (onChange)="onTabChange($event)" appStopAccordionHomeEnd>
        <p-tabPanel header="Выбор документа" [cache]="false" [disabled]="false">
          <ng-template pTemplate="header">
            <i class="pi pi-plus mr-2"></i>
            <span>Загрузка из файла</span>
          </ng-template>
          <div class="col-6 sm:col-12 mt-2 mr-2">
            <input type="file" (change)="onFileChange($event)" accept=".xls,.xlsx" [multiple]="false" />
          </div>
          <!--<div class="col-6 sm:col-12 mt-2 mr-2">
        <p-fileUpload mode="basic" accept=".xls,.xlsx" [maxFileSize]="10000000" label="Import" chooseLabel="Import"
                      customUpload="true" [auto]="true" (onProgress)="onProgress($event)"
                      (onUpload)="onBasicUpload($event)" class="mr-4 "></p-fileUpload>
      </div>-->
        </p-tabPanel>

        <p-tabPanel header="Paste from clipboard" [cache]="false" [disabled]="false">
          <ng-template pTemplate="header">
            <i class="pi pi-sitemap mr-2"></i>
            <span>Вставка из буфера копирования</span>
          </ng-template>
          <div class="grid formgrid">
            <textarea pInputTextarea [(ngModel)]="textSource" [style]="{width: '100%', height: '150px'}"></textarea>

            <div class="grid justify-content-start col-6 mt-2">
              <div class="grid col-3">
                <p-radioButton name="groupname" value="tab" label="TAB разделители" [(ngModel)]="textType" (onClick)="onTextTypeClick($event)"></p-radioButton>
              </div>
              <div class="grid col-2">
                <p-radioButton name="groupname" value="csv" label="CSV файл" [(ngModel)]="textType" (onClick)="onTextTypeClick($event)"></p-radioButton>
              </div>
            </div>
            <div class="grid justify-content-end col-6 mt-2">
              <p-button label="Вставить данные" (onClick)="onInsertText($event)" class="mr-2" [disabled]="!canInsertTextData"></p-button>
            </div>
          </div>

        </p-tabPanel>
      </p-tabView>
    </p-accordionTab>

    <p-accordionTab [selected]="openFieldSelector">
      <ng-template pTemplate="header">
        <h5>Сопоставление полей</h5>
      </ng-template>
      <div class="grid" appStopAccordionHomeEnd>
        <div class="col-2 xl:col-2 sm:col-4" *ngFor="let fld of paramsMap">
          <h5 [class.text-bold]="fld.fieldIsMandatory">{{fld.fieldLabel}}</h5>
          <p-dropdown [options]="columns" [(ngModel)]="fld.importColumnName" [showClear]="!fld.fieldIsMandatory" [autoDisplayFirst]="false" [required]="fld.fieldIsMandatory"></p-dropdown>
        </div>
      </div>

      <p-table appStopAccordionHomeEnd
               [columns]="columns"
               [value]="dataSource"
               [paginator]="true"
               [rows]="10"
               [showCurrentPageReport]="true"
               styleClass="p-datatable p-datatable-gridlines p-datatable-striped">
        <ng-template pTemplate="header" let-columns>
          <tr>
            <th *ngFor="let col of columns" [class.met]="columnMet(col)" style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis">
              {{col}}
            </th>
          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-rowData let-columns="columns">
          <tr>
            <td *ngFor="let col of columns" [class.met]="columnMet(col)" style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis">
              {{rowData[col]}}
            </td>
          </tr>
        </ng-template>
      </p-table>

      <div class="col-12 grid formgrid" appStopAccordionHomeEnd>
        <div class="field-checkbox col-2">
          <p-checkbox [(ngModel)]="searchOld" [binary]="true" inputId="sm0"></p-checkbox>
          <label for="sm0">Искать устаревшие</label>
        </div>
        <div class="field-checkbox col-2">
          <p-checkbox [(ngModel)]="searchComplex" [binary]="true" inputId="sm1"></p-checkbox>
          <label for="sm1">Искать сборные</label>
        </div>
        <div class="field-checkbox col-2">
          <p-checkbox [(ngModel)]="partialMatch" [binary]="true" inputId="sm2"></p-checkbox>
          <label for="sm2">Частичное совпадение</label>
        </div>
        <div class="field-checkbox col-2">
          <p-checkbox [(ngModel)]="clearBefore" [binary]="true" inputId="shc"></p-checkbox>
          <label for="shc">Очистить существующие</label>
        </div>
        <div class="field-checkbox col-2">
          <p-checkbox [(ngModel)]="overwriteExisted" [binary]="true" inputId="shd"></p-checkbox>
          <label for="shd">Обновлять существующие</label>
        </div>
        <!--<div class="p-field-checkbox col-4">
      <p-checkbox [(ngModel)]="addExisted" [binary]="true" inputId="shi" (onChange)="onShowItemChange($event)"></p-checkbox>
      <label for="shi">Добавлять к существующим</label>
    </div>-->
      </div>

      <div class="grid formgrid justify-content-end">
        <p-button label="Вставить данные" (onClick)="onDataInsert($event)" class="mr-2" [disabled]="!canInsertData"></p-button>
      </div>
    </p-accordionTab>

    <p-accordionTab [selected]="openImportResult">
      <ng-template pTemplate="header">
        <h5>Импорт данных</h5>
      </ng-template>
      <app-list-product-array appStopAccordionHomeEnd [products]="products"></app-list-product-array>
    </p-accordionTab>

  </p-accordion>
